import type {
  FormLabelProps as ChakraFormLabelProps} from '@chakra-ui/react'
import {
  Box,
  FormLabel as ChakraFormLabel,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react'
import CustomTooltip from 'brokertslib/src/components/CustomTooltip'
import React from 'react'

import { QuestionMarkIcon } from './QuestionMarkIcon'

export interface FormLabelProps extends ChakraFormLabelProps {
  children: React.ReactNode
  tooltip?: string | React.ReactNode
  optional?: boolean | undefined
  isLoading?: boolean | undefined
}

export const FormLabel = ({
  children,
  tooltip,
  optional,
  isLoading,
  ...rest
}: FormLabelProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        gap: 2,
        alignItems: 'center',
        w: '100%',
      }}
    >
      <Box
        sx={{ display: 'flex', columnGap: 4, justifyContent: 'space-between' }}
      >
        <Box
          sx={{
            display: 'flex',
            columnGap: 2,
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            justifyItems: 'center',
          }}
        >
          <ChakraFormLabel {...rest}>{children}</ChakraFormLabel>

          {tooltip && (
            <Box ml={2} sx={{ lineHeight: 0 }}>
              <CustomTooltip
                trigger="clickHover"
                hasArrow
                label={tooltip}
                maxW={500}
                placement="top"
              >
                <QuestionMarkIcon />
              </CustomTooltip>
            </Box>
          )}
        </Box>

        {optional ||
          (isLoading && (
            <Stack direction="row" sx={{ ml: 'auto' }}>
              {optional && (
                <Text variant="textMuted" sx={{ fontSize: 'sm' }}>
                  Nepovinné
                </Text>
              )}

              {isLoading && <Spinner />}
            </Stack>
          ))}
      </Box>
    </Box>
  )
}
